<template>
    <div class="phone-number-input-container w-full relative" :id="`${id}-input-container`">
        <input type="hidden" :name="name" :value="phoneNumber" />
        <div class="input-group w-full">
            <span class="input-group-addon rounded-tl rounded-bl" :class="{ 'cursor-pointer': !countryCode }" @click.prevent="editCountryCode">
                <span>+{{ prefix }}</span>
                <i class="zmdi zmdi-caret-down ml-4" v-if="!countryCode"></i>

            </span>
            <input type="text" :id="id" class="form-control" :class="{'border-danger': hasError}" v-model="number" :required="required">
        </div>
        <div class="phone-country-selector" :id="`${id}-country-selector`" v-show="editingCountryCode">
            <select class="w-full" ref="country_code_select">
                <option value="">{{ trans('surveys.please_select') }}</option>
            </select>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'select2';
import { http } from '../../../http';

export default {
    name: 'PhoneNumberInput',

    props: {
        countryCode: {
            required: false,
            default: null,
        },

        defaultCountryCode: {
            required: false,
            default: null,
        },

        countryEditable: {
            required: false,
            default: true,
        },

        value: {
            required: false,
            default: '',
        },

        name: {
            required: false,
            default: 'phone'
        },

        id: {
            required: false,
            default: 'phone',
        },

        required: {
            required: false,
            default: false,
        },

        dropdownParent: {
            required: false,
            default: null,
        },

        hasError: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            allCountries: [],
            countriesLoaded: false,
            countriesLoading: false,
            prefix: '',
            number: '',
            editingCountryCode: false,
        }
    },

    mounted() {
        if (this.countryCode) {
            this.prefix = this.countryCode;
            this.countriesLoaded = true;
        } else {
            this.prefix = this.default_prefix;
            this.countriesLoaded = false;
        }

        if (this.value !== '') {
            this.parseValue(this.value);
        }
    },

    beforeUnmount() {
        if ($(this.$refs.country_code_select).data('select2')) {
            $(this.$refs.country_code_select).select2('destroy');
        }
    },

    methods: {
        buildSelectList() {
            let vm = this;

            const dropdownParent = this.dropdownParent
                ? $(this.dropdownParent)
                : $(this.$refs.country_code_select).parent()

            $(this.$refs.country_code_select).select2({
                theme: "bootstrap",
                dropdownParent,
                language: {
                    errorLoading: function() {
                        return trans('clients.select_1')
                    },
                    loadingMore: function() {
                        return trans('clients.select_2')
                    },
                    noResults: function() {
                        return trans('clients.select_3')
                    },
                    searching: function() {
                        return trans('clients.select_4')
                    }
                },
                placeholder: trans('surveys.please_select'),
                data: this.allCountries,
            }).on('select2:select', function (e) {
                vm.prefix = e.params.data.id;
                vm.editingCountryCode = false;
            }).on('select2:close', function (e) {
                vm.editingCountryCode = false;
            });
        },

        async loadCountries() {
            this.countriesLoading = true;

            return http.get('/phone-country-codes')
                .then(({ data }) => {
                    this.countriesLoading = false;
                    this.allCountries = data;
                    this.countriesLoaded = true;
                    return true;
                })
                .catch((error) => {
                    this.countriesLoading = false;
                    this.allCountries = [];
                    this.countriesLoaded = false;
                    return false;
                })
        },

        async editCountryCode() {
            if (this.countryCode) {
                // country code is set in stone and not changable
                return;
            }

            if (!this.countriesLoaded) {
                await this.loadCountries();
                this.buildSelectList();
            }

            this.editingCountryCode = true;
            this.$nextTick(() => {
                $(this.$refs.country_code_select).select2('open');
            });
        },

        parseValue(value) {
            // we expect the country code and the number to be separated by a space
            const [countryCode, number] = String(value).split(/\s+(.+)/);

            if (countryCode && number && number.trim() !== '') {
                this.prefix = countryCode.replace(/[^0-9]/g, '');
                this.number = number.replace(/[^0-9]/g, '');
                return;
            }

            this.prefix = this.default_prefix;
            this.number = value?.replace(/[^0-9]/g, '');
        }
    },

    computed: {
        user() {
            return this.$store.state.auth ? this.$store.state.auth.user : null;
        },

        default_prefix() {
            if (this.user) {
                return Config.get('countries.' + this.user.country + '.phone_contry_code')
            }

            return Config.get('countries.' + locale + '.phone_contry_code')
        },

        phoneNumber() {
            if (this.number && this.number.trim() !== '') {
                return `+${this.prefix} ${this.number}`;
            }

            return '';
        },
    },

    watch: {
        value(newValue, oldValue) {
            this.parseValue(newValue);
        },

        phoneNumber(newNumber, oldNumber) {
            this.$emit('input', newNumber);
        },
    }
}
</script>

<style>
.phone-country-selector .select2-container {
    width: 100% !important;
    z-index: 10;
}

.phone-country-selector {
    top: 40px;
    left: 0px;
    right: 0px;
    position: absolute;
}
</style>
